import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { isDefined } from '@fi-shared/utils/is-defined';
import {
    IChecklistReportBusinessAreaData,
    IChecklistReportBusinessUnitData,
    IChecklistReportSelection,
} from '../../checklist-report';
import { ObjectTypes } from '@fi-shared/types';

export class ChecklistReportSelectionDropdownSettingsModel extends DropdownSettingsModelV2<IChecklistReportSelection> {
    SelectedModel: number[] | number;
    onSelectionDataChanged: (shouldUpdateBusinessAreas?: boolean) => void;
    onSelectionChanged: () => void;

    constructor(selections: IChecklistReportSelection[], SelectedModel: number[]) {
        super();
        this.setDataSet(selections);
        this.SelectedModel = SelectedModel || [];
    }

    isSelectionDefault() {
        const selectItem = this.dataSet.find((item) => item.Id === this.SelectedModel);
        return selectItem ? selectItem.IsDefault : false;
    }

    isSelectionSaved() {
        const selectItem = this.dataSet.find((item) => item.Id === this.SelectedModel);
        return selectItem && selectItem.Id;
    }

    getSelection() {
        return this.dataSet.find((item) => item.Id === this.SelectedModel);
    }

    getDefaultSelection() {
        const res = this.dataSet.filter((item: IChecklistReportSelection) => item.IsDefault);
        return res.length ? res[0] : null;
    }
}

export class ChecklistReportBusinessUnitsDropdownSettingsModel extends DropdownSettingsModelV2<IChecklistReportBusinessUnitData> {
    SelectedModel: string[];

    constructor(businessUnitsData: IChecklistReportBusinessUnitData[], SelectedModel: string[]) {
        super();
        this.dataValueField = 'IdObjectType';
        this.filterBy = 'Name';
        this.setDataSet(businessUnitsData);
        this.dataValueParentField = 'OwnerId';
        this.SelectedModel = SelectedModel || [];
        // add composite key to business units
        this.dataSet.forEach((item: IChecklistReportBusinessUnitData) => {
            item.ChildItems.forEach((childItem: IChecklistReportBusinessUnitData) => {
                this.updateKeyValue(childItem);
            });
            this.updateKeyValue(item);
        });
    }

    getKeyValue(item: IChecklistReportBusinessUnitData) {
        return JSON.stringify({ ObjectId: item.Id, ObjectType: item.ObjectType });
    }

    updateKeyValue(item: IChecklistReportBusinessUnitData) {
        item[this.dataValueField] = this.getKeyValue(item);
    }

    getSelectedBusinessUnitIds() {
        return this.SelectedModel.filter((item: string) => isDefined(item))
            .filter((item: string) => {
                return JSON.parse(item).ObjectType === ObjectTypes.BusinessUnit;
            })
            .map((item: string) => {
                return JSON.parse(item).ObjectId;
            });
    }
}

export class ChecklistReportBusinessAreasDropdownSettingsModel extends DropdownSettingsModelV2<IChecklistReportBusinessAreaData> {
    SelectedModel: number[];

    constructor(SelectedModel: number[]) {
        super();
        this.SelectedModel = SelectedModel || [];
    }
}
